import { createContext } from 'react';
import { ISingleSignOnParam } from '../Components/SingleSignOn/SingleSignOn';

interface IAvenyContext {
  singleRoutineMode: ISingleRoutineMode;
  didLoginViaSingleSignOn: boolean;
  setDidLoginViaSingleSignOn: (newvalue: boolean) => void;
  formHasChanged: boolean;
  setFormHasChanged: (value: boolean) => void;
  singleSignOnParams: ISingleSignOnParam[];
  setSingleSignOnParams: (params: ISingleSignOnParam[]) => void;
  openChoiceDialog: boolean;
  setOpenChoiceDialog: (
    newValue: boolean,
    openChoiceCallback?: () => void
  ) => void;
  openChoiceCallback: (() => void) | undefined;
}

export interface ISingleRoutineMode {
  enabled: boolean;
  rutinId: number | null;
}

const defaultValues: IAvenyContext = {
  singleRoutineMode: {
    enabled: window.env && window.env.singleRoutineMode,
    rutinId: 0,
  },
  didLoginViaSingleSignOn: false,
  setDidLoginViaSingleSignOn: () => {},
  singleSignOnParams: [],
  setSingleSignOnParams: () => {},
  formHasChanged: false,
  setFormHasChanged: () => {},
  openChoiceDialog: false,
  setOpenChoiceDialog: () => {},
  openChoiceCallback: () => {},
};

/**
 * Context där vi håller värden som ska vara globala för hela applikationen
 */
export const AvenyContext = createContext<IAvenyContext>(defaultValues);

export const AvenyContextProvider = AvenyContext.Provider;
export const AvenyContextConsumer = AvenyContext.Consumer;
